<div class="main-wrap vertical-scrollbale">
    <div class="h-100 d-flex align-items-center p-3">
        <video controls [src]="vurl"></video>
    </div>
    
</div>